// Среда (env) на стороне консоли.
//
// ЗАЧЕМ: FBS теперь отдаёт env ('air' | 'water' | 'land' | комбинация
// 'air,water' для гибридов). Без разбора здесь аквадрон неотличим от
// воздушного БАС, а слой 'vessels' в layers.ts пустует.
//
// КЛЮЧЕВОЕ: env — НЕ БИТОВАЯ МАСКА. Авиа-дрон, взлетающий с морского дрона,
// в момент взлёта принадлежит двум средам сразу, поэтому значение — список.
// env независим от traffic_source: source описывает ТИП/ИСТОЧНИК
// (0=sim, 1=drone, 2=manned), env — СРЕДУ.

/** Среда наблюдения: одна или несколько. */
export type Env = 'air' | 'water' | 'land'

/** Гибрид: аппарат принадлежит нескольким средам одновременно. */
export type EnvSet = Env[]

export const ENV_VALUES: readonly Env[] = ['air', 'water', 'land'] as const

/** Человекочитаемые подписи для UI. */
export const ENV_LABEL: Record<Env, string> = {
  air: 'Воздух',
  water: 'Вода',
  land: 'Земля',
}

/**
 * Разбирает env из наблюдения в список сред.
 *
 * Совместимость: у старых наблюдений env нет → ['air'] (обратная
 * совместимость, все прежние наблюдения — воздушные).
 * Неизвестные значения отбрасываются; если не осталось ни одного
 * известного — возвращается ['air'].
 */
export function envList(raw: unknown): EnvSet {
  const NONE: EnvSet = ['air']
  if (raw === null || raw === undefined) return NONE
  let parts: string[]
  if (Array.isArray(raw)) {
    parts = raw.map((v) => String(v).toLowerCase().trim())
  } else {
    parts = String(raw)
      .toLowerCase()
      .replace(/;/g, ',')
      .split(',')
      .map((s) => s.trim())
  }
  // Канонический порядок air -> water -> land, дубликаты убираются.
  const out = ENV_VALUES.filter((e) => parts.includes(e)) as EnvSet
  return out.length ? out : NONE
}

/** Одна среда (для одиночных меток). Гибрид склеивается через « + ». */
export function envLabel(raw: unknown): string {
  return envList(raw)
    .map((e) => ENV_LABEL[e])
    .join(' + ')
}

/** Короткая подпись без пробелов — для цвета/идентификатора. */
export function envKey(raw: unknown): string {
  return envList(raw).join(',')
}

/** Принадлежит ли наблюдение среде. Для гибрида — да любой из списка. */
export function envHas(raw: unknown, env: Env): boolean {
  return envList(raw).includes(env)
}

/** Гибрид ли это (более одной среды). */
export function envIsHybrid(raw: unknown): boolean {
  return envList(raw).length > 1
}
